/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Profile_Editors_Split_Auto_HintInputs */

const en_us2_profile_editors_split_auto_hint = /** @type {(inputs: Profile_Editors_Split_Auto_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The app chooses by your days. Today: ${i?.name}.`)
};

const pt_br2_profile_editors_split_auto_hint = /** @type {(inputs: Profile_Editors_Split_Auto_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O app escolhe pelos seus dias. Hoje: ${i?.name}.`)
};

const es_419_profile_editors_split_auto_hint = /** @type {(inputs: Profile_Editors_Split_Auto_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La app elige según tus días. Hoy: ${i?.name}.`)
};

const pt_pt2_profile_editors_split_auto_hint = /** @type {(inputs: Profile_Editors_Split_Auto_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A app escolhe pelos teus dias. Hoje: ${i?.name}.`)
};

const fr_fr2_profile_editors_split_auto_hint = /** @type {(inputs: Profile_Editors_Split_Auto_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'app choisit selon tes jours. Aujourd'hui : ${i?.name}.`)
};

const de_de2_profile_editors_split_auto_hint = /** @type {(inputs: Profile_Editors_Split_Auto_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die App wählt nach deinen Tagen. Aktuell: ${i?.name}.`)
};

const it_it2_profile_editors_split_auto_hint = /** @type {(inputs: Profile_Editors_Split_Auto_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'app sceglie in base ai tuoi giorni. Oggi: ${i?.name}.`)
};

/**
* | output |
* | --- |
* | "The app chooses by your days. Today: {name}." |
*
* @param {Profile_Editors_Split_Auto_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_split_auto_hint = /** @type {((inputs: Profile_Editors_Split_Auto_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Split_Auto_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_split_auto_hint(inputs)
	if (locale === "es-419") return es_419_profile_editors_split_auto_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_split_auto_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_split_auto_hint(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_split_auto_hint(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_split_auto_hint(inputs)
	return en_us2_profile_editors_split_auto_hint(inputs)
});
export { profile_editors_split_auto_hint as "profile-editors.split_auto_hint" }